<template>
  <div class="single-filter-container">
    <div class="radio-button-container">
      <div v-for="(item, index) in items"
           :key="item[id]">
        <div class="filter-radio">
          <label>
            {{item[title]}}
            <input type="radio"
                   :id="`${item.id}${index}`"
                   :value="item[id]"
                   v-model="selectedFilter"
                   @input="selectFilter">
            <span></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'SingleSelectFilter',
  props: {
    id: {
      type: String,
    },
    filter: {
      type: Number,
    },
    filterDelay: {
      type: Number,
    },
    items: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      selectedFilter: this.filter,
    };
  },
  created() {
    this.selectFilter = debounce(this.selectFilter, this.filterDelay);
  },
  watch: {
    filter(value) {
      if (value) this.selectedFilter = value;
    },
  },
  methods: {
    selectFilter() {
      this.$emit('inputFilter', this.selectedFilter);
    },
  },
};
</script>
<style lang="scss">
.single-filter-container {
  position: absolute;
  margin: 13px 0 0 10px;
  z-index: 10;
}

.radio-button-container {
  min-width: 250px;
  padding: 5px 0 10px 10px;
  background-color: #D3DADD;
}

.filter-radio {
  label {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 400;
  color: #768191;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      ~ span {
        background-color:#e8ecee;
        &:hover {
          background-color:#e8ecee;;
        }
        &:after {
          content: "";
          position: absolute;
          display: none;
        }
      }
      &:checked {
        ~ span {
        border: 1px solid #009aff;
        background-color: #e8ecee;
          &:after {
            display: block;
          }
        }
      }
    }
  }
  span {
    position: absolute;
    top: 0;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: #eee;
    border-radius: 50%;
    &:after {
      top: 4px;
      left: 4px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #009aff;
    }
  }
}
</style>
